import React from 'react';

import DeviceNames from './DeviceNames';
import DeviceIcons from './DeviceIcons';
import DeviceValues from './DeviceValues';

import EditMenu from './EditMenu';

const Device = ({ device, user }) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <DeviceIcons device={device} />

      <div className="overflow-hidden mr-auto">
        <DeviceValues device={device} style="truncate text-gray-800 text-lg sm:text-xl md:text-xl lg:text-xl" />
        <DeviceNames device={device} style="text-sm line-clamp-1 text-gray-400" />
      </div>

      <EditMenu device={device} user={user} />
    </div>
  );
};

export default Device;
